import type {
  ContractedService,
  HiredInsurancePlan,
  HiredInsuranceVehicle,
  HiresInsurancePlanDetail,
  InsuranceStatus,
} from '~/domain/Assegurou/contractedServices';
import type {
  HiredInsurancePlanDTO,
  HiredInsuranceVehicleDTO,
  InsuranceDTO,
} from '~/dto/Assegurou/contractedServices';

const vehicleDTOtoVehicle = (
  vehicleDTO: HiredInsuranceVehicleDTO
): HiredInsuranceVehicle => ({
  plate: vehicleDTO.placa,
  manufacturer: vehicleDTO.fabricante,
  model: vehicleDTO.modelo,
  yearModel: vehicleDTO.anoModelo,
  manufactureYear: vehicleDTO.anoFabricacao,
});

type PlanDetailKeysDTO = keyof HiredInsurancePlanDTO;

const planDetailDTOToPlanDetail = (
  planDetailDTO: HiredInsurancePlanDTO
): HiresInsurancePlanDetail[] => {
  const details: HiresInsurancePlanDetail[] = [];

  const detailKeysDTO: PlanDetailKeysDTO[] = [
    'detalhe1',
    'detalhe2',
    'detalhe3',
    'detalhe4',
    'detalhe5',
    'detalhe6',
    'detalhe7',
    'detalhe8',
    'detalhe9',
    'detalhe10',
    'detalhe11',
    'detalhe12',
    'detalhe13',
    'detalhe14',
    'detalhe15',
    'detalhe16',
    'detalhe17',
    'detalhe18',
    'detalhe19',
    'detalhe20',
  ];

  detailKeysDTO.forEach((detailKey) => {
    if (planDetailDTO[detailKey] !== '') {
      const [description, value] = planDetailDTO[detailKey].split(': ');
      details.push({ description: description ?? '', value: value ?? '' });
    }
  });

  return details;
};

const planDTOToPlan = (planDTO: HiredInsurancePlanDTO): HiredInsurancePlan => {
  const planName = planDTO.nomePlano.split(': ')[1];
  const planDescription = planDTO.descricaoPlano.split(': ')[1];
  const planFipeValue = planDTO.valorFipe.split(': ')[1]?.replace(/\D/g, '');
  const formattedFipeValue = Number(planFipeValue) / 100;
  const planFranchiseValue = planDTO.valorFranquia.split(': ')[1];

  return {
    name: planName ?? '',
    description: planDescription ?? '',
    fipeValue: formattedFipeValue,
    franchiseValue: planFranchiseValue ?? '',
    details: planDetailDTOToPlanDetail(planDTO),
  };
};

export const contractedServiceDTOtoContractedService = (
  serviceDTO: InsuranceDTO
): ContractedService => {
  const status = {
    Pendente: 'pending',
    Emitido: 'approved',
  };

  return {
    holderName: serviceDTO.segurado.nomeSegurado,
    policyNumber: serviceDTO.numeroApolice,
    policyUrl: serviceDTO.urlArquivoApolice,
    certificateCode: serviceDTO.codigoCertificado,
    productCode: serviceDTO.codigoProduto,
    productName: serviceDTO.descricaoProduto,
    productDescription: serviceDTO.descricaoPlano,
    saleDate: serviceDTO.dataEfetivacaoVenda.substring(
      0,
      serviceDTO.dataEfetivacaoVenda.indexOf('T')
    ),
    vehicle: serviceDTO.veiculo
      ? vehicleDTOtoVehicle(serviceDTO.veiculo)
      : null,
    plan: serviceDTO.plano ? planDTOToPlan(serviceDTO.plano) : null,
    validity: serviceDTO.vigencia,
    value: serviceDTO.valorSeguro,
    insuranceCompanyName: serviceDTO.empresaRefLogo,
    chosenPaymentMethod: serviceDTO.formaPagtoEscolhida,
    chosenInstallmentQuantity: serviceDTO.qtdParcelaEscolhida,
    chosenInstallmentValue: serviceDTO.valorParcelaEscolhida,
    status: status[serviceDTO.statusProposta] as InsuranceStatus,
    cancellationDate: serviceDTO.cancelamentoDataHora,
    luckyNumber:
      serviceDTO.serieSorte && serviceDTO.numeroSorte
        ? `${serviceDTO.serieSorte}-${serviceDTO.numeroSorte}`
        : undefined,
  };
};
